/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Duplicate Lines`)
};

const es_rd_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar Líneas Duplicadas`)
};

const de_rd_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelte Zeilen entfernen`)
};

const nl_rd_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijder Dubbele Regels`)
};

const fr_rd_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les lignes en doublon`)
};

const it_rd_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi Righe Duplicate`)
};

const pt_br2_rd_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover Linhas Duplicadas`)
};

const pt_rd_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover Linhas Duplicadas`)
};

const ja_rd_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複行削除`)
};

const zh_rd_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去除重复行`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_tool_name", locale)
	if (locale === "en") return en_rd_tool_name(inputs)
	if (locale === "es") return es_rd_tool_name(inputs)
	if (locale === "de") return de_rd_tool_name(inputs)
	if (locale === "nl") return nl_rd_tool_name(inputs)
	if (locale === "fr") return fr_rd_tool_name(inputs)
	if (locale === "it") return it_rd_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_rd_tool_name(inputs)
	if (locale === "pt") return pt_rd_tool_name(inputs)
	if (locale === "ja") return ja_rd_tool_name(inputs)
	return zh_rd_tool_name(inputs)
};